import React from 'react';
import type { ReactNode } from 'react';

import BoardIcon from '@atlaskit/icon/core/board';
import PageIcon from '@atlaskit/icon/core/page';
import TaskIcon from '@atlaskit/icon/core/task';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import { token } from '@atlaskit/tokens';

import type { MeetingActionItem } from './meetingTypes.ts';

/**
 * Maps an action item to its leading icon, derived from the 1-click action key.
 *
 * The design shows a per-item glyph indicating what the item turns into
 * (a page/PRD, Jira work items, a whiteboard). Items with no action payload get
 * a neutral task icon.
 */
export const getActionItemIcon = (item: MeetingActionItem): ReactNode => {
	const iconColor = token('color.icon.subtle');
	const key = item.action?.key ?? '';

	if (key.includes('page') || key.includes('confluence-page')) {
		return <PageIcon label="" color={iconColor} />;
	}
	if (key.includes('jira') || key.includes('issue')) {
		return <BoardIcon label="" color={iconColor} />;
	}
	if (key.includes('whiteboard')) {
		return <WhiteboardIcon label="" color={iconColor} />;
	}
	return <TaskIcon label="" color={iconColor} />;
};
